import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import useStyles from '../../assets/styles/style';
import TaskCompletedHeading from './taskCompletedHeading';
import TaskCompleted from './taskCompleted';
import { useParams } from 'react-router-dom';

const TaskCompletedMain = () => {
  const classes = useStyles();
  const { taskId } = useParams<{ taskId: string }>();

  return (
    <div className={classes.formMainContainer}>
      <Box className={classes.formMainHeadingBox}>
        <TaskCompletedHeading />
      </Box>
      <Box component="main" className={classes.formMainBox}>
        <Paper className={classes.formMainpaper}>
          {taskId && <TaskCompleted taskID={taskId} />}
        </Paper>
      </Box>
    </div>
  );
};

export default TaskCompletedMain

